import {useNavigation} from '@react-navigation/native';
import React from 'react';

import {WriteLanternOptions} from '../../lib/ble2/v2/PeakDevice/IPeakDevice';
import {UnitLighting} from './unit-lighting';

export const useRealtimeUnitLighting = (
  key: string,
  light?: WriteLanternOptions,
) => {
  const {dequeuePreviewLight, queuePreviewLight, updateEnqueuedLight} =
    UnitLighting.useContainer();
  const navigation = useNavigation();

  React.useEffect(() => {
    const beforeRemove = navigation.addListener('beforeRemove', () => {
      dequeuePreviewLight(key);
    });

    const focus = navigation.addListener('focus', () => {
      if (!light) return;

      queuePreviewLight(key, light);
    });

    const unsubscribe = () => {
      beforeRemove();
      focus();
    };

    return unsubscribe;
  }, [navigation, key, dequeuePreviewLight, queuePreviewLight, light]);

  React.useEffect(() => {
    if (!light) return;

    updateEnqueuedLight(key, light);
  }, [light, key, updateEnqueuedLight]);
};
